var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownloadAlt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 1L9 9L10.2 7.4C10.5314 6.95817 11.1582 6.86863 11.6 7.2C12.0418 7.53137 12.1314 8.15817 11.8 8.6L8.8 12.6C8.61115 12.8518 8.31476 13 8 13C7.68525 13 7.38886 12.8518 7.2 12.6L4.2 8.6C3.86863 8.15817 3.95817 7.53137 4.4 7.2C4.84183 6.86863 5.46863 6.95817 5.8 7.4L7 8.99999L7 1C7 0.447715 7.44771 0 8 0C8.55228 0 9 0.447715 9 1ZM2 11C2 10.4477 1.55228 10 1 10C0.447715 10 0 10.4477 0 11V14C0 15.1046 0.895431 16 2 16H14C15.1046 16 16 15.1046 16 14V11C16 10.4477 15.5523 10 15 10C14.4477 10 14 10.4477 14 11V14H2V11Z",
    fill: "#73777C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadAlt);
export default __webpack_public_path__ + "static/media/download-alt.07beb081fd8191444302bbcb190e5a3f.svg";
export { ForwardRef as ReactComponent };